<template>
  <div class="flex h-screen">
    <!-- Sidebar, hanya tampil jika bukan di halaman login -->
    <AppSidebar v-if="showLayout" :isOpen="sidebarOpen" />

    <!-- Main Content -->
    <div class="flex-1 flex flex-col">
      <!-- Navbar, hanya tampil jika bukan di halaman login -->
      <AppNavbar v-if="showLayout" @toggle-sidebar="toggleSidebar" />

      <!-- Router View -->
      <router-view></router-view>
      <!-- <div :class="{ 'p-4 pt-20': showLayout, 'flex justify-center items-center h-screen': !showLayout }">
       
      </div> -->
    </div>
  </div>
</template>

<script>
import AppNavbar from "@/components/AppNavbar.vue";
import AppSidebar from "@/components/AppSidebar.vue";

export default {
  components: {
    AppNavbar,
    AppSidebar,
  },
  data() {
    return {
      sidebarOpen: true,
    };
  },
  computed: {
    showLayout() {
      // Hanya tampilkan navbar dan sidebar jika bukan di halaman login
      return this.$route.path !== "/login";
    },
  },
  methods: {
    toggleSidebar() {
      this.sidebarOpen = !this.sidebarOpen;
    },
  },
};
</script>
